import { render, staticRenderFns } from "./ButtonFull.vue?vue&type=template&id=4521adfe&scoped=true&"
import script from "./ButtonFull.vue?vue&type=script&lang=js&"
export * from "./ButtonFull.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFull.vue?vue&type=style&index=0&id=4521adfe&lang=scss&scoped=true&"
import style1 from "./ButtonFull.vue?vue&type=style&index=1&id=4521adfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4521adfe",
  null
  
)

export default component.exports